import { XML_DrawLinkPDF } from "./XML_DrawLinkPDF.js";
import { XML_DrawLinkPPT } from "./XML_DrawLinkPPT.js";
import { enumXMLType } from "../constants";

export function XML_DrawHyperLink(target, x, y, clipRect, drawElement, layer) {
  var docType = drawElement.GetDocType();

  if (docType == enumXMLType.PDF) {
    XML_DrawLinkPDF(target, x, y, clipRect, drawElement, layer);
  } else XML_DrawLinkPPT(target, x, y, clipRect, drawElement, layer);
}
